<template>
    <div>
        <Checkbox
            :checked="item.response"
            @input="handleInput"
        />

    </div>
</template>

<script>
    import Checkbox from '@/components/Form/CheckboxButton.vue';

    export default {

        components: { Checkbox },

        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        computed: {},

        methods: {
            handleInput(value) {
                this.$store.commit('conduct/changeResponse', {
                    item: this.item.uuid,
                    response: value,
                    responded: (value === true),
                });
            },
        },
    };
</script>
